<template>
  <div :class="width() <= 1024 ? 'toast-mobile-container' : 'toast-container'">
    <transition-group name="fade">
      <div v-for="toast in toasts" :key="toast.id" :class="['toast', toast.severity]">
        {{ jsConfetti(toast) }}
        <i :class="['pi', severityIcon(toast.severity), 'toast-icon']" style="font-size: 2rem"></i>
        <div>
          <div class="summary">{{ toast.summary }}</div>
          <div class="detail">{{ toast.detail }}</div>
        </div>
        <Button icon="pi pi-times" :severity="severityClass(toast.severity)" class="close-btn" text @click="closeToast(toast.id)"></Button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import JSConfetti from 'js-confetti';

const jsConfetti = new JSConfetti();

export default {
  props: {
    toasts: Array,
  },
  methods: {
    closeToast(id) {
      this.$emit('close-toast', id);
    },
    width() {
      return window.innerWidth;
    },
    severityClass(severity) {
      switch (severity) {
        case 'success':
          return 'success';
        case 'error':
          return 'danger';
        case 'info':
          return 'info';
        default:
          return 'warning';
      }
    },
    severityIcon(severity) {
      switch (severity) {
        case 'success':
          return 'pi-check-circle';
        case 'error':
          return 'pi-times-circle';
        case 'info':
          return 'pi-info-circle';
        default:
          return 'pi-exclamation-circle';
      }
    },
    jsConfetti(toast) {
      if (toast.confetti) {
        jsConfetti.addConfetti({
          confettiRadius: 5,
          confettiNumber: 1500,
          confettiColors: ['#ffff54', '#47ff7e', '#9670ff', '#ff85ff', '#fbf1bd', '#ffbe45'],
        });
      }
      return;
    },
  },
  emits: ['close-toast'],
  watch: {
    toasts: {
      handler(newToasts) {
        newToasts.forEach((toast) => {
          if (toast.visible && !toast.timeout) {
            toast.timeout = setTimeout(() => {
              this.closeToast(toast.id);
            }, toast.until || 5000);
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 1rem;
  right: 20%;
  left: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}

.toast-mobile-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}
.toast {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: #eee;
  z-index: 1000;
}
.toast.success {
  background-color: #c9fcc9e3;
  color: #009a3b;
  border-left: #009a3b 0.5rem solid;
}
.toast.error {
  background-color: #fcc9c9e3;
  color: #ff2a2a;
  border-left: #ff0000 0.5rem solid;
}

.toast.info {
  background-color: #c9ddfce3;
  color: #2196f3;
  border-left: #2196f3 0.5rem solid;
}

.toast .summary {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0.5rem;
}

.detail {
  font-size: 14px;
}

.toast-icon {
  margin: 0 0.5rem;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.close-btn {
  margin-left: auto;
}
</style>
